/**
 * StudentExperienceRadar — country-aware radar-chart wrapper.
 *
 * Picks the right national survey instrument for this uni:
 *   UK → NSS radar (8 themes, HESA verified)
 *   AU → QILT SES radar (5 focus areas, QILT verified)
 *   US → NSSE radar (10 engagement indicators, TIER-MAPPED)
 *   other → nothing (we don't fake it for countries without a
 *   published national survey)
 */
import NssRadarChart from "@/components/app/NssRadarChart";
import QiltRadarChart from "@/components/app/QiltRadarChart";
import NsseRadarChart from "@/components/app/NsseRadarChart";

export default function StudentExperienceRadar({ uni }) {
  if (!uni?.id || !uni?.country) return null;
  const c = uni.country;
  if (c === "UK" || c === "United Kingdom") return <NssRadarChart uniId={uni.id} />;
  if (c === "AU" || c === "Australia") return <QiltRadarChart uniId={uni.id} />;
  if (c === "US" || c === "United States") return <NsseRadarChart uniId={uni.id} />;
  return null;
}
